// extracted by mini-css-extract-plugin
export default {"submitBtn":"JobOffers-JobOfferForm__submitBtn--GMVeN"};